import React from 'react';
import { CTAButton } from './CTAButton';

// Hero "Kit": una sola composición estática con las portadas reales como protagonista.
// Las portadas son solo imagen: no abren ningún preview. La exploración interactiva vive
// en la sección "El método H·E·R" (components/method), donde cada recurso tiene su muestra.

const CDN = 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/';
// Portadas nuevas en R2 (archivos.simpleymejor.com). Los nombres de archivo son los que
// figuran hoy en el bucket her-ebooks.
const R2 = 'https://archivos.simpleymejor.com/';
type KitPiece = {
  id: string;
  title: string;
  img: string;
  // Posición dentro del contenedor, en % del ANCHO del kit (top incluido), y rotación.
  left: number;
  top: number;
  width: number;
  rotate: number;
  z: number;
};

// Composición: 3 piezas atrás (Recetario · Protocolo · Noche) y 3 adelante
// (Movimiento · Tracker · Dulce). Ninguna tapa el título de otra.
const PIECES: KitPiece[] = [{
  id: 'recetario',
  title: 'Recetario H.E.R.',
  img: CDN + 'sOWIBzOpm0inWncyzKYoM_430x.jpg?v=1780543245',
  left: 3,
  top: 13,
  width: 29,
  rotate: -4,
  z: 20
}, {
  id: 'protocolo',
  title: 'Protocolo H.E.R.',
  img: R2 + 'httpsarchivos.simpleymejor.comhercoversher-protocolo-cover.png.png',
  left: 29,
  top: 0,
  width: 42,
  rotate: 0,
  z: 30
}, {
  id: 'noche',
  title: 'Noche en Calma',
  img: CDN + 'qushb3WzLl3BYpA9n1eL_430x.jpg?v=1780543244',
  left: 68,
  top: 12,
  width: 29,
  rotate: 4,
  z: 20
}, {
  id: 'movement',
  title: 'H.E.R. Movement',
  img: CDN + 'S8SNVUZHdzf8t092yIlAK_430x.jpg?v=1780543245',
  left: 3,
  top: 53,
  width: 30,
  rotate: -3,
  z: 40
}, {
  id: 'tracker',
  title: 'Tracker Premium',
  img: CDN + 'v5gVLGm07qY3WP7hCr5Mp_430x.jpg?v=1780543245',
  left: 37,
  top: 61,
  width: 26,
  rotate: 2,
  z: 40
}, {
  id: 'dulce',
  title: 'H.E.R. Dulce',
  img: R2 + 'httpsarchivos.simpleymejor.comhercoversher-dulce-cover.png.png',
  left: 67,
  top: 51,
  width: 30,
  rotate: 3,
  z: 40
}];

// Alto de la composición en % del ancho (la pieza más baja termina en ~96).
const KIT_HEIGHT_PCT = 98;
export function HeroSectionKit() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-hero relative overflow-hidden pt-8 pb-12" data-id="element-233" data-mp="3skpbqmm3rw56">
      <div className="absolute left-[8%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/15 to-transparent" data-id="element-234" data-mp="3simbzav5eon9" />
      <div className="absolute right-[8%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/15 to-transparent" data-id="element-235" data-mp="p402gsv4y8bt" />

      <div className="relative z-10 mx-auto w-full max-w-[480px] px-5 text-center" data-id="element-236" data-mp="b3fl814vckkf">
        {/* Marca + fórmula */}
        <div className="flex items-center gap-4 text-[#C8A870]" data-id="element-237" data-mp="f4hjofqyoslc">
          <span className="h-px flex-1 bg-[#C8A870]/30" data-id="element-238" data-mp="2vugct3gzwogd" />
          <span className="font-display text-[30px] font-semibold leading-none tracking-[0.4em] pl-[0.4em]" data-id="element-239" data-mp="2vwspb13zi6m1">
            H·E·R
          </span>
          <span className="h-px flex-1 bg-[#C8A870]/30" data-id="element-240" data-mp="2sbzbi05mkom0" />
        </div>
        <p className="mt-2 font-display text-[19px] text-[#F0E8D8]/90" data-id="element-241" data-mp="2ndpgbpjwho0e">
          21 días · 3 fases · 1 estrategia
        </p>

        {/* Promesa */}
        <h1 className="mt-5 font-display font-semibold leading-[1.04] tracking-tight text-[#F0E8D8]" data-id="element-242" data-mp="329n5uozbju3n">
          <span className="block" style={{
          fontSize: 'clamp(36px, 10.6vw, 52px)'
        }} data-id="element-243" data-mp="2xcepmtxqe051">
            Volvé a sentirte más liviana.
          </span>
          <span className="block italic text-gradient-gold my-2" style={{
          fontSize: 'clamp(28px, 8vw, 38px)',
          lineHeight: 1.08
        }} data-id="element-244" data-mp="24nptzafg2n0o">
            Comida, movimiento y descanso
          </span>
          <span className="block" style={{
          fontSize: 'clamp(26px, 7.4vw, 34px)'
        }} data-id="element-245" data-mp="2ekcetz7rte2p">
            en 21 días.
          </span>
        </h1>

        <p className="mx-auto mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 font-body text-[12px] font-medium uppercase tracking-[0.16em] text-[#C8A870]" data-id="element-246" data-mp="1lwq1w0cnkx36">
          <span data-id="element-247" data-mp="p6wcengz23my">✦ Comida real</span>
          <span data-id="element-248" data-mp="t6wnpz8rxyps">✦ Movimiento suave</span>
          <span data-id="element-249" data-mp="t7yct7mmklqi">✦ Hábitos simples</span>
        </p>

        {/* Kit completo: composición estática a sangre en el ancho, siempre visible */}
        <div className="relative -mx-5 mt-5" data-id="element-250" data-mp="y3wwihx0dfkl">
          <div className="relative mx-auto w-full max-w-[480px]" style={{
          aspectRatio: `100 / ${KIT_HEIGHT_PCT}`
        }} data-id="element-251" data-mp="12wzqgr5p6r1b">
            <div className="pointer-events-none absolute inset-0 -z-10 flex items-center justify-center" data-id="element-252" data-mp="17vjecx3uqcwb">
              <div className="h-[75%] w-[85%] rounded-full bg-gold/10 blur-[80px]" data-id="element-253" data-mp="1ct2uk2k40zqw" />
            </div>
            {PIECES.map(piece => <div key={piece.id} className="absolute block overflow-hidden rounded-[3px] border border-[#C8A870]/25 bg-[#090807] p-0 shadow-[0_18px_40px_rgba(0,0,0,0.55)]" style={{
            left: `${piece.left}%`,
            // top se expresa en % del ancho; se convierte a % del alto del contenedor.
            top: `${piece.top / KIT_HEIGHT_PCT * 100}%`,
            width: `${piece.width}%`,
            aspectRatio: '3 / 4',
            zIndex: piece.z,
            transform: `rotate(${piece.rotate}deg)`
          }} data-id="element-254" data-mp="1lvlry754mk5r">
                <img src={piece.img} alt={piece.title} loading="eager" decoding="async" draggable={false} fetchPriority={piece.id === 'protocolo' ? 'high' : undefined} className="block h-full w-full object-cover pointer-events-none" data-id="element-255" data-mp="36cv0txhfjrqs" />
              </div>)}
          </div>
        </div>

        {/* Cierre */}
        <div className="mt-9 flex items-center gap-4" data-id="element-256" data-mp="3u48se17rbjap">
          <span className="h-px flex-1 bg-[#C8A870]/30" data-id="element-257" data-mp="3u1e4fzpjbgcj" />
          <p className="font-display font-semibold leading-[1.05] text-[#F0E8D8]" style={{
          fontSize: 'clamp(24px, 7vw, 30px)',
          maxWidth: '78%'
        }} data-id="element-258" data-mp="3p2t480aa8wo3">
            Todo H.E.R. en un solo lugar.
          </p>
          <span className="h-px flex-1 bg-[#C8A870]/30" data-id="element-259" data-mp="2dmutzt3dc4la" />
        </div>

        <div className="mx-auto mt-6 flex w-full max-w-md flex-col items-center space-y-4" data-id="element-260" data-mp="29lsqh02f56di">
          <CTAButton section="hero" onClick={scrollToOffer} data-id="element-261" data-mp="2b5ud6v3tp5xt">
            Acceder a H.E.R. →
          </CTAButton>
          <p className="text-center font-body text-[11px] uppercase tracking-[0.14em] text-[#C8A870] md:text-[12px]" data-id="element-262" data-mp="2g2uktagbmgr1">
            ✦ Acceso inmediato&nbsp;&nbsp; ✦ Garantía 30 días
          </p>
        </div>
      </div>
    </section>;
}